// extracted by mini-css-extract-plugin
module.exports = {"op_toast":"style_op_toast__2SS-V","op_toast_close":"style_op_toast_close__1mUPE"};